import Image from 'components/Common/Image'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import MarkdownRender from 'LuxKit/MarkdownRender'
import Heading from 'LuxKit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import { rem } from 'polished'
import styled from 'styled-components'
import { renderMarkdown } from 'lib/string/markdownUtils'

const Overlay = styled(LayoutContainer)`
  height: 100%;
  width: 100%;
  display: grid;
  padding: 0;
  grid-template-columns: 1fr;
  align-items: flex-end;

  ${mediaQueryUp.tablet} {
    grid-template-rows: 1fr;
    grid-template-columns: ${rem(440)};
    padding-bottom: ${rem(40)};
    align-items: center;
  }
`

const OverlayContent = styled(Sheet)`
  min-height: 50%;
`

interface Props {
  promo: App.MerchandiseHeroPromo
}

function MerchandiseLandingPageHeroImageOverlay(props: Props) {
  const { promo } = props
  const markedTitleText = renderMarkdown(promo.title)
  return <Overlay>
    <OverlayContent padding={20} tabletPadding={32} background="neutral-eight">
      <VerticalSpacer gap={16}>
        {promo.brandImage && <Image image={promo.brandImage} height={50} disableBlur />}
        <Heading variant="heading2" dangerouslySetInnerHTML={{ __html: markedTitleText }} />
        <MarkdownRender content={promo.description} fontSize="medium" />
        {promo.to && <Group direction="horizontal" horizontalAlign="end">
          <TextButton kind="primary" to={promo.to}>{promo.buttonText}</TextButton>
        </Group>}
      </VerticalSpacer>
    </OverlayContent>
  </Overlay>
}

export default MerchandiseLandingPageHeroImageOverlay
